export default __webpack_public_path__ + "static/media/yellow-error.b0efc8e7.svg";